import Component from "../classes/Component";
import { Chart, DoughnutController, ArcElement, LinearScale  } from "chart.js";
Chart.register(DoughnutController, ArcElement, LinearScale );
import ChartDataLabels from "chartjs-plugin-datalabels";

export default class Charts extends Component {
  constructor() {
    super({});
    this.element = document.querySelector("[data-components-charts]");
    this.init();
  }
  init() {
    if (this.element) {
      this.initChart();
    }
  }
  initChart() {
    let el = this.element;
    let number = JSON.parse(el.getAttribute('data-number'));
    let bg1 = el.getAttribute('data-bg1');
    let bg2 = el.getAttribute('data-bg2');
    let bg3 = el.getAttribute('data-bg3');
    let bg4 = el.getAttribute('data-bg4');
    let bg5 = el.getAttribute('data-bg5');

    const data = {
      datasets: [
        {
          data: number,
          backgroundColor: [bg1,bg2,bg3,bg4,bg5],
          hoverBackgroundColor: [bg1,bg2,bg3,bg4,bg5],
          hoverOffset: 4,
        },
      ],
    };

    const chart = new Chart(this.element, {
      type: "doughnut",
      data: data,
      options: {
        rotation: -90,
        circumference: 180,

        plugins: {
          tooltip: {
            enabled: false,
          },

          datalabels: {
            formatter: (value, context) => {
              return Math.round(value) + "%";
            },
            color: ["#FFFFFF","#FFFFFF","#FFFFFF","#094154","#094154"],
            font: function(context) {
              var width = context.chart.width;
              var size = Math.round(width / 32);

              return {
                family: "Mabry Pro",
                weight: "bold",
                size: size
              };
            }
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }
}
